
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import DialogActions from '@mui/material/DialogActions';

import styles from './styles';

function MyDialogActions(props) {
    return (
        <DialogActions className={props.fullScreen ? props.classes.fullScreen : props.classes.dialog}>
            {props.children}
        </DialogActions>
    );
}

MyDialogActions.propTypes = {
    fullScreen: PropTypes.bool
};

export default withStyles(MyDialogActions, styles);